import { AxiosPromise } from 'axios';
import { http } from 'services';

export const Get = (orgId: string): AxiosPromise =>
  http.request.get(`/api/permissions/${orgId}`);

// Per-role granted permission-key arrays. Keys are validated/sanitized server-side.
export const Update = (
  orgId: string,
  rolePermissions: Record<string, string[]>,
): AxiosPromise => http.request.put(`/api/permissions/${orgId}`, { rolePermissions });

export const Reset = (orgId: string): AxiosPromise =>
  http.request.delete(`/api/permissions/${orgId}`);

export const ResetRole = (orgId: string, role: string): AxiosPromise =>
  http.request.delete(`/api/permissions/${orgId}/roles/${role}`);
